/* eslint-disable */
const BASE_REPORT = {
  BASE_REPORT_APPVERSION: 'base/report/appVersion',
  BASE_REPORT_VARIABLE: 'base/report/variable',
  BASE_REPORT_PROVINCE: 'base/report/province',
  BASE_REPORT_CAR: 'base/report/car',
  BASE_REPORT_REASON: 'base/report/reason',
  BASE_REPORT_CITY: 'base/report/city',
  BASE_REPORT_PAYMENT: 'base/report/payment'
}
export default BASE_REPORT
